import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ProductCard from './ProductCard';
import { markdownToExcerpt } from '../utils/text';
import { useT } from '../i18n';
import { useProductTexts } from '../utils/productI18n';
import { Helmet } from 'react-helmet-async';
import { titreSeo } from './Seo';

const CategoryPage = () => {
  const t = useT('visual-catalog');
  const tp = useProductTexts(); // titre, description courte et étiquette traduits (repli : français)
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const VAT_RATE = 0.2;

  useEffect(() => {
    axios.get('https://joli-mot.fr/api-2026.php', {
      params: {
        cleApi: '34KVHFQSP226YTk4n256QP6rGbqhA5w2ymY7W3pLwdbuc3i75',
        service: 'getProductsByCategory',
        category_id: categoryId,
      },
    })
      .then((response) => setProducts(response.data.data))
      .catch((error) => console.error('Erreur chargement catégorie :', error));
  }, [categoryId]);

  const titre = t('visual-catalog.category.title', { name: categoryId.replace('-', ' ') });

  return (
    <Box sx={{ padding: 3 }}>
      {/* Ancienne page de liste (atteinte par le fil d'Ariane), hors sitemap : son titre, et pas d'indexation
          (les pages d'entrée du catalogue sont l'accueil et les pages par événement). */}
      <Helmet>
        <title>{titreSeo(titre)}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Typography variant="h1" sx={{ marginBottom: 4, color: '#c48f8b', textAlign: 'center' }}>
        {titre}
      </Typography>
      <Grid container spacing={3}>
        {/* On ne liste que les produits ayant au moins un visuel rattaché (config_carte) */}
        {products.filter((product) => product.visuels?.length > 0).map((product) => {
          const prixTTC = parseFloat(product.prix_ttc) || 0;
          const prixHT = parseFloat(product.prix_ht) || 0;
          const priceTTC = prixTTC || (prixHT * (1 + VAT_RATE)) || 0;
          const shown = tp(product);

          return (
            <Grid item xs={12} md={4} key={product.id}>
              <ProductCard
                visuels={product.visuels?.length ? product.visuels : (product.featured_image ? [{ url: product.featured_image }] : [])}
                title={shown.titre}
                price={priceTTC}
                badge={product.etiquette}
                badgeLabel={shown.etiquette}
                linkTo={`/produit/${product.url}`}
                editPath={`/gestion-catalogue?editId=${product.idProd}`}
              >
                <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                  {markdownToExcerpt(shown.description_courte || shown.description, 100)}
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ marginTop: 2 }}
                  component={Link}
                  to={`/produit/${product.url}`}
                >
                  {t('visual-catalog.category.details')}
                </Button>
              </ProductCard>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default CategoryPage;
